import React, { Component } from "react";

class ProjAdminTabs extends Component {
  renderProjSetupTab = (tab) => {
    const { selectedProjSetupTabId, onProjSetupTabSelect } = this.props;
    return (
      <li key={tab.tabId} className="nav-item">
        <div
          className={`nav-link border border-secondary border-bottom-0 pointer-cursor ${
            tab.tabId === selectedProjSetupTabId ? "active pa-tab--border" : ""
          }`}
          id={tab.tabId + "_tab"}
          data-toggle="tab"
          role="tab"
          onClick={onProjSetupTabSelect}
        >
          {tab.label}
        </div>
      </li>
    );
  };

  render() {
    const { tabs } = this.props;
    return (
      <ul className="nav nav-tabs border-0 ml-1" role="tablist">
        {tabs.map((tab) => this.renderProjSetupTab(tab))}
      </ul>
    );
  }
}

export default ProjAdminTabs;
